import {
  ROOM_ACCESS_TYPES,
  ROOM_TYPES,
} from "@circle-react/helpers/liveStreamRoomHelpers";
import type { Room } from "@circle-react/types/Live/Room";

export const useCanOpenRoomInfo = (room: Room, isHost: boolean) => {
  const roomType = room?.room_type || ROOM_TYPES.STREAM;
  const { description: roomDescription } = room;

  const isPublicStream = room?.access_type === ROOM_ACCESS_TYPES.PUBLIC_STREAM;
  const shouldDisplayPublicStreamLink = isHost && isPublicStream;

  return {
    canOpenRoomInfo: shouldDisplayPublicStreamLink || roomDescription,
    roomType,
  };
};
